import Heading, { HeadingProps } from '@/decodo/components/atoms/Heading';
import AnimatedEl from '@/lib/motion';

type AnimatedHeadingProps = {
  children: React.ReactNode;
  separator?: string;
} & HeadingProps;

export const AnimatedHeading = ({
  children,
  separator,
  ...rest
}: AnimatedHeadingProps) => {
  const chunks =
    typeof children === 'string' && separator !== undefined
      ? children.split(' ').map((chunk) => chunk.split(separator))
      : [[children]];

  const isLastChunk = (i: number) => i === chunks.length - 1;

  return (
    <Heading {...rest}>
      <AnimatedEl
        el='div'
        variants={{}}
        transition={{
          staggerChildren: 0.0175,
          ease: 'easeOut',
        }}
      >
        {chunks.map((chunk, i) => (
          <span key={i} className='inline-block whitespace-pre'>
            {chunk.map((word, i) => (
              <AnimatedEl
                el='span'
                key={i}
                className='inline-block origin-left'
                variants={variants}
              >
                {word}
              </AnimatedEl>
            ))}
            {isLastChunk(i) ? '' : ' '}
          </span>
        ))}
      </AnimatedEl>
    </Heading>
  );
};

const variants = {
  initial: {
    y: -12,
    opacity: 0,
    filter: 'blur(16px)',
  },
  animate: {
    y: 0,
    opacity: 1,
    filter: 'blur(0px)',
  },
};
